// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#all_wrapper.profile .prof_1 .ph.edit .inner[data-v-54d949a7]{align-items:center;display:flex}", "",{"version":3,"sources":["webpack://./resources/js/Pages/my_profile.vue"],"names":[],"mappings":"AACA,8DAEI,kBAAA,CADA,YACJ","sourcesContent":["\n#all_wrapper.profile .prof_1 .ph.edit .inner {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
